import styled, { css } from 'styled-components';
import { warnColor, wurGreen, wurGreenLight } from '../../style/colors';

const StyledButton = styled.button`
    padding: 0.4em 1em;
    border: none;
    box-shadow: 2px 3px 5px 0px rgba(0, 0, 0, 0.75);
    border-radius: 4px;

    &:active {
        transform: translate(1px, 2px);
        box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.75);
    }

    ${(props) =>
        props.busy &&
        `
        transform: translate(1px, 2px);
        box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.75);
    `}

    &:hover {
        background: #fff;
    }
`;

const Button = (props) => {
    return <StyledButton {...props} />;
};

export default Button;

const primary = css`
    background: ${wurGreen};
    color: #fff;

    &&:hover {
        background: ${(props) => (props.busy ? wurGreen : wurGreenLight)};
    }
`;
const secondary = css`
    border: 2px solid ${wurGreen};
    color: ${wurGreen};

    &&:hover {
        ${(props) =>
            !props.busy &&
            `background: inherit; color: ${wurGreenLight}; border-color: ${wurGreenLight};`}
    }
`;

export const RunButton = styled(Button)`
    width: 100%;
    min-width: 180px;
    padding: 0.4em 0.6em;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0.1em;
    height: 80px;
    box-sizing: border-box;

    ${(props) => (props.variant === 'secondary' ? secondary : primary)};
`;

export const RestartButton = styled.button`
    border: none;
    color: ${warnColor};
    text-decoration: underline;
    padding: 0.2em 0.5em;
    border-radius: 4px;

    &:hover {
        background: ${warnColor};
        color: #fff;
    }
`;
